import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';

export const hasRegion = (regions: GeoEventRegion[], id: number): boolean =>
  regions.some((region) => region.id === id);

export const withoutRegion = (
  regions: GeoEventRegion[],
  id: number,
): GeoEventRegion[] => regions.filter((region) => region.id !== id);
